import React from 'react'
import Img from 'react-image'
import Moment from 'react-moment'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import { Typography } from '@material-ui/core'
import { submitQrCode, clearQrData } from 'ducks/qr'
import { Loading } from 'components'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { QRScannerContainer, HeaderContainer, QRScannerBody, DocumentDataSection } from './styled'

import imgLogo from 'assets/images/DTGO_Logo_mini.png'
import qrIcon from 'assets/images/iconqr.png'

const QRScanner = (props) => {
  const { qrData } = props

  React.useEffect(() => {
    let elms = document.getElementsByName('qrValue')
    if (elms.length) {
      elms[0].focus()
    }
  })

  const submitQr = (qrValue) => {
    props.submitQrCode(qrValue)
    props.change('qrValue', '')
    setTimeout(() => {
      props.clearQrData(qrValue)
    }, 120000)
  }

  return (
    <QRScannerContainer>
      <HeaderContainer>
        <div className='applicationName'>
          <Img src={imgLogo} style={{width:'2.5rem'}} />
          <div style={{width:'1rem'}}/>
          <Typography variant='h6' color='inherit'>
            {process.env.REACT_APP_NAME}
          </Typography>
        </div>
      </HeaderContainer>
      <QRScannerBody>
        <div className='leftContent'>
          <span className='title'>Billing QR Scanner</span>
          <Img src={qrIcon} />
          <form onSubmit={props.handleSubmit(values => submitQr(values.qrValue))}>
            <Field 
              name='qrValue' 
              type={type.text} 
              placeHolder='Enter QRNumber or Barcode Number' 
              containerStyle={{
                marginTop: '10px',
                width: '100%',
                padding: '0px 15px',
              }}
              component={FieldInput} 
            />
          </form>
        </div>
        <div className='rightContent'>
          {
            Object.entries(qrData).length ? 
            <React.Fragment>
              {
                qrData.status === 2 ? 
                  <span className='title' style={{ color: 'red' }} >เอกสารเลขที่ {qrData.documentNumber} เอกสารนี้ทำซ้ำ หรือ มีการวางเอกสารเรียบร้อยแล้ว
                  กรุณาตรวจสอบเลขที่เอกสาร หรือ ติดต่อกลับบริษัทของท่าน</span> :
                  <span className='title'>เอกสารเลขที่ {qrData.documentNumber} ทำการส่งเอกสารเรียบร้อยแล้ว</span>
              }
              <DocumentDataSection style={{ flexDirection: 'row' }}>
                <div className='row' style={{ flex: 1 }}>
                  <div className='title' style={{ marginRight: '10px', flex: 'none' }}>Document Number:</div>
                  <div className='value'>{qrData.documentNumber}</div>
                </div>
                <div className='row' style={{ flex: 1 }}>
                  <div className='title' style={{ marginRight: '10px', flex: 'none' }}>Billing Date:</div>
                  <div className='value'><Moment format='DD MMM YYYY - HH:mm:ss'>{qrData.billingDate}</Moment></div>
                </div>
              </DocumentDataSection>
              <DocumentDataSection>
                <span className='sectionTitle'>ข้อมูล Vendor</span>
                <div className='row'>
                  <div className='title'>ชื่อบริษัท</div>
                  <div className='value'>{qrData.vendorName}</div>
                </div>
                <div className='row'>
                  <div className='title'>ที่อยู่</div>
                  <div className='value'>{qrData.vendorAddress}</div>
                </div>
              </DocumentDataSection>
              <DocumentDataSection>
                <span className='sectionTitle'>ข้อมูลบริษัท</span>
                <div className='row'>
                  <div className='title'>ชื่อบริษัท</div>
                  <div className='value'>{qrData.companyName}</div>
                </div>
                <div className='row'>
                  <div className='title'>ที่อยู่</div>
                  <div className='value'>{qrData.companyAddress}</div>
                </div>
              </DocumentDataSection>
            </React.Fragment> :
            <span className='title'>กรุณาสแกน QR CODE เพื่อนำส่งเอกสารสำหรับวางบิล</span>
          }
        </div>
      </QRScannerBody>
      <Loading />
    </QRScannerContainer>
  )
}

const mapStateToProps = (state) => ({
  qrData: state.qr.qrData
})

const mapDispatchToProps = { 
  submitQrCode,
  clearQrData,
}

QRScanner.propTypes = {}

QRScanner.defaultProps = {}

const QRForm = reduxForm({
  form: 'formQR',
})(QRScanner)

export default connect(mapStateToProps, mapDispatchToProps)(QRForm)